<template>
    <div>
        <block v-if="loading" />
        <v-card flat class="pa-4 bar">
            <div class="d-flex justify-end align-center">
                <v-btn
                    small
                    class="btn-save mr-1"
                    @click="printconfig"
                >
                    <v-icon>
                        mdi-printer
                    </v-icon>
                </v-btn>
                <v-btn
                    small
                    class="btn-save mr-1"
                    @click="getReportSales"
                >
                    <v-icon>
                        mdi-magnify
                    </v-icon>
                   
                </v-btn>
            </div>
        </v-card>
        <v-row class="mt-2">
            <v-col cols="12" md="6">
                <v-select
                    v-model="search.month"
                    :items="monthList"
                    item-text="monthName"
                    item-value="monthIndex"
                    label="Mes"
                    outlined
                    attach
                    dense
                    @change="getReportSales"
                ></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                    v-model="search.year"
                    label="Año"
                    outlined
                    attach
                    dense
                    type="number"
                />
            </v-col>
        </v-row>
        <hr/>
        <br/>
        <v-row>
            <v-col cols="12" md="4">
                <v-radio-group v-model="printType" row>
                    <v-radio label="Ver formato csv" value="1"></v-radio>
                    <v-radio label="Ver oficial hacienda" value="2"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="12" md="4" v-if="printType == '1'">
                <v-checkbox
                    v-model="integrateBranchData"
                    label="Integrar datos de sucursales"
                    @change="onIntegrateBranchDataChange"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-alert
                            v-bind="attrs"
                            v-on="on"
                            v-show="invalidRowsCount > 0"
                            type="warning"
                            dense
                            outlined
                            @click="getAlerts()"
                            style="cursor: pointer;"
                        >
                            Errores: {{ invalidRowsCount }}
                        </v-alert>
                    </template>

                    <span>
                        Se encontraron {{ invalidRowsCount }} comprobantes sin clasificacion. Se recomienda corregirlos antes de descargar el anexo.
                    </span>
                </v-tooltip>
            </v-col>
        </v-row>
        <template v-if="printType == '1'">
            <GeneralFilter
            :filterEndpoint="$API.accountingreports.getFilterPurchasesByDate" :search="search"
            @emptyFilter="getReportSales" @filtered="filterHandler">
                <DxDataGrid 
                :dataSource="DataTable"
                @row-prepared="onRowPrepared"
                @exporting="onExporting"
                :scrolling="{ useNative: true }"
                :column-auto-width="true"
                >
                    <DxColumn
                        caption="Acciones"
                        cell-template="actionTemplate"
                        :width="100"
                        :allow-exporting="false"
                        :fixed="true"
                        fixed-position="left"
                    />
                    <template #actionTemplate="{ data }">
                        <v-btn
                            small
                            color="warning"
                            @click="openEditDialog(data.data)"
                            icon
                        >
                            <v-icon small>mdi-alert-circle</v-icon>
                        </v-btn>
                    </template>
                    <DxColumn
                        v-for="col in columns"
                        :key="col.dataField"
                        :data-field="col.dataField"
                        :caption="col.caption"
                        :visible="col.visible !== false"
                    />
                    <DxExport :enabled="true" />
                    <DxPager :showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
                    <DxPaging defaultPageSize="5" />
                </DxDataGrid>
            </GeneralFilter>
        </template>
        <template v-if="printType == '2'">
            <v-row>
                <v-col cols="12" md="2">
                    <v-btn class="btn-save" @click="onExportingToPdf()">Imprimir formato oficial</v-btn>
                </v-col>
                <v-col cols="12" md="2">
                    <v-btn class="btn-save" @click="onExportingToExcel()">Exportar a Excel</v-btn>
                </v-col>
                <v-col cols="12" md="8">
                    <v-checkbox v-model="hidePagination" label="Ocultar numeración de páginas"></v-checkbox>
                </v-col>
            </v-row>
            <br/>
            <DxDataGrid 
            :word-wrap-enabled="true"
            ref="dxdatagridcompras"
            :dataSource="DataTable"
            @row-prepared="onRowPrepared"
            @exporting="onExporting"
            >
                <DxColumn
                    caption="Acciones"
                    cell-template="actionTemplate2"
                    :width="80"
                    :allow-exporting="false"
                    :fixed="true"
                    fixed-position="left"
                />
                <template #actionTemplate2="{ data }">
                    <v-btn
                        v-if="hasEmptyRequiredFields(data.data)"
                        small
                        color="warning"
                        @click="openEditDialog(data.data)"
                        icon
                    >
                        <v-icon small>mdi-alert-circle</v-icon>
                    </v-btn>
                </template>
                <DxColumn
                    v-for="col in columns2"
                    :key="col.dataField"
                    :data-field="col.dataField"
                    :caption="col.caption"
                    :alignment="col.alignment"
                    :format="col.format"
                />
                <DxExport :enabled="true" />
                <DxPager :showPageSizeSelector="true" allowedPageSizes="[5, 10, 20]" />
                <DxPaging defaultPageSize="5" />
                <DxSummary>
                    <DxTotalItem
                    column="FECHA DE EMISIÓN"
                    display-format="TOTALES"
                    />
                    <DxTotalItem
                    column="COMPRAS INTERNAS EXENTAS Y/O NO SUJETAS"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                    cssClass="right-column"
                    
                    />
                    <DxTotalItem
                    column="COMPRAS INTERNAS GRAVADAS"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                   cssClass="right-column"
                    />
                    <DxTotalItem
                    column="CRÉDITO FISCAL"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    column="TOTAL DE COMPRAS"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    column="Retención a Terceros"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    column="Retención 2%"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                    cssClass="right-column"
                    />
                    <DxTotalItem
                    column="Compras a Sujeto Excluido"
                    summary-type="sum"
                    :value-format="customCurrencyFormat"
                    display-format="{0}"
                    cssClass="right-column"
                    />
                </DxSummary>
            </DxDataGrid>
        </template>
        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        ></alerts>

        <!-- Modal de edición de campos faltantes -->
        <v-dialog v-model="editDialog.show" max-width="900px" persistent>
            <v-card>
                <v-card-title class="headline lighten-4">
                    <v-icon color="success" class="mr-2">mdi-pencil</v-icon>
                    Edicion de clasificaciones
                </v-card-title>
                <v-card-text class="pt-4">
                    <div class="subtitle-2 grey--text text--darken-1 mb-3">
                        Información del registro:
                    </div>
                    <v-card outlined class="mb-4 pa-3">
                        <v-row dense>
                            <v-col cols="12" md="6">
                                <div class="caption grey--text">Proveedor</div>
                                <div class="body-2"><strong>{{ editDialog.data['NOMBRE DEL PROVEEDOR'] }}</strong></div>
                            </v-col>
                            <v-col cols="12" md="3">
                                <div class="caption grey--text">Documento</div>
                                <div class="body-2">{{ editDialog.data['NÚMERO DE DOCUMENTO'] }}</div>
                            </v-col>
                            <v-col cols="12" md="3">
                                <div class="caption grey--text">Fecha</div>
                                <div class="body-2">{{ editDialog.data['FECHA DE EMISIÓN'] }}</div>
                            </v-col>
                        </v-row>
                    </v-card>

                    
                    
                    <v-row>
                        <v-col cols="12">
                            <div class="subtitle-2 grey--text text--darken-1 mb-4">
                                Campos requeridos:
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="editDialog.data['TIPO DE OPERACIÓN']"
                                label="TIPO DE OPERACIÓN *"
                                outlined
                                dense
                                disabled
                                hint="Este campo no es editable actualmente"
                                persistent-hint
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ClasificationRentaAutocomplete 
                                v-model="editDialog.data['CLASIFICACIÓN']"
                            />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="editDialog.data['SECTOR']"
                                :items="sectorProveedores"
                                item-text="Valores"
                                item-value="Codigo"
                                label="SECTOR *"
                                outlined
                                dense
                                clearable
                                attach
                                :error="!editDialog.data['SECTOR'] || editDialog.data['SECTOR'].trim() === ''"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-select
                                v-model="editDialog.data['TIPO DE COSTO / GASTO']"
                                :items="tipoIngresoProveedores"
                                item-text="Valores"
                                item-value="Codigo"
                                label="TIPO DE COSTO / GASTO *"
                                outlined
                                dense
                                clearable
                                attach
                                :error="!editDialog.data['TIPO DE COSTO / GASTO'] || editDialog.data['TIPO DE COSTO / GASTO'].trim() === ''"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeEditDialog">
                        Cancelar
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        @click="saveEditedData"
                        :disabled="!isFormValid()"
                        :loading="loading"
                    >
                        <v-icon left small>mdi-content-save</v-icon>
                        Guardar Cambios
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <template v-for="win in windowsList">
             <component :is="win.component" :key="win.key" v-bind="win.props" />
        </template>

    </div>
</template>

<script>
    
    //import {mapState} from 'vuex';
    import {mapGetters} from 'vuex';
    import {DxDataGrid, DxPager, DxPaging, DxExport, DxSummary, DxTotalItem, DxColumn} from 'devextreme-vue/data-grid';
    import GeneralFilter from '../../../components/GeneralFilter.vue';
    import Alerts from '@/components/Alerts.vue';
    import Block from '@/components/Block.vue';
    import { printToExcel } from "@/helpers/printToexcel";
    import SubPrint from '../SubPrint.vue';
    import { jsPDF } from 'jspdf'
    import 'jspdf-autotable';
    import { exportDataGrid } from 'devextreme/pdf_exporter';
    import { addSignaturesAccountantAndAuditor } from '../../../utils/addSignatures';
    import ClasificationRentaAutocomplete from '@/components/Misc/ClasificationRentaAutocomplete.vue';
    import ExcelJS from 'exceljs';
    import { saveAs } from 'file-saver';

    export default {
        name: "PurchaseReport",
        components: {
            DxDataGrid,
            DxPager,
            DxPaging,
            Block,
            Alerts,
            GeneralFilter,
            DxExport,
            SubPrint,
            DxSummary,
            DxTotalItem,
            DxColumn,
            ClasificationRentaAutocomplete
        },
        props: ['win'],
        data() {
            return {
                print: {
                    show: false,
                    header: {
                        month: null,
                        year: null,
                        reportType: null,
                    },
                    data: [],
                },
                windowsList: [],
                DataTable: [],
                panel: 0,
                tab: null,
                key: 0,
                loading: false,
                search: {
                    month: null,
                    year: null,
                    ID_Branch: null
                },
                printType: '1',
                integrateBranchData: false,
                alert: {
                    type: "success",
                    show: false,
                    header: "",
                    body: "",
                },
                monthList: [
                    {monthName: 'Enero', monthIndex: 1},
                    {monthName: 'Febrero', monthIndex: 2},
                    {monthName: 'Marzo', monthIndex: 3},
                    {monthName: 'Abril', monthIndex: 4},
                    {monthName: 'Mayo', monthIndex: 5},
                    {monthName: 'Junio', monthIndex: 6},
                    {monthName: 'Julio', monthIndex: 7},
                    {monthName: 'Agosto', monthIndex: 8},
                    {monthName: 'Septiembre', monthIndex: 9},
                    {monthName: 'Octubre', monthIndex: 10},
                    {monthName: 'Noviembre', monthIndex: 11},
                    {monthName: 'Diciembre', monthIndex: 12},
                ],
                yearLIst: [
                    {text: '2020', value: 2020},
                    {text: '2021', value: 2021},
                    {text: '2022', value: 2022},
                    {text: '2023', value: 2023},
                ],
                columns: [
                    { dataField: "FECHA DE EMISIÓN", caption: "FECHA DE EMISIÓN" },
                    { dataField: "CLASE DE DOCUMENTO", caption: "CLASE DE DOCUMENTO" },
                    { dataField: "TIPO DE DOCUMENTO", caption: "TIPO DE DOCUMENTO" },
                    { dataField: "NÚMERO DE DOCUMENTO", caption: "NÚMERO DE DOCUMENTO" },
                    { dataField: "NIT O NRC DEL PROVEEDOR", caption: "NIT O NRC DEL PROVEEDOR" },
                    { dataField: "NOMBRE DEL PROVEEDOR", caption: "NOMBRE DEL PROVEEDOR" },
                    { dataField: "COMPRAS INTERNAS EXENTAS Y/O NO SUJETAS", caption: "COMPRAS INTERNAS EXENTAS Y/O NO SUJETAS" },
                    { dataField: "INTERNACIONES EXENTAS Y/O NO SUJETAS", caption: "INTERNACIONES EXENTAS Y/O NO SUJETAS" },
                    { dataField: "IMPORTACIONES EXENTAS Y/O NO SUJETAS", caption: "IMPORTACIONES EXENTAS Y/O NO SUJETAS" },
                    { dataField: "COMPRAS INTERNAS GRAVADAS", caption: "COMPRAS INTERNAS GRAVADAS" },
                    { dataField: "INTERNACIONES GRAVADAS DE BIENES", caption: "INTERNACIONES GRAVADAS DE BIENES" },
                    { dataField: "IMPORTACIONES GRAVADAS DE BIENES", caption: "IMPORTACIONES GRAVADAS DE BIENES" },
                    { dataField: "CRÉDITO FISCAL", caption: "CRÉDITO FISCAL" },
                    { dataField: "TOTAL DE COMPRAS", caption: "TOTAL DE COMPRAS" },
                    { dataField: "DUI DEL PROVEEDOR", caption: "DUI DEL PROVEEDOR" },
                    { dataField: "TIPO DE OPERACIÓN", caption: "TIPO DE OPERACIÓN", required:true },
                    { dataField: "CLASIFICACIÓN", caption: "CLASIFICACIÓN", required:true },
                    { dataField: "SECTOR", caption: "SECTOR", required:true },
                    { dataField: "TIPO DE COSTO / GASTO", caption: "TIPO DE COSTO / GASTO", required:true },
                    { dataField: "NÚMERO DE ANEXO", caption: "NÚMERO DE ANEXO" },
                ],
                columns2: [
                    { dataField: "FECHA DE EMISIÓN", caption: "Fecha" },
                    { dataField: "NÚMERO DE DOCUMENTO", caption: "Código de Generación" },
                    { dataField: "NIT O NRC DEL PROVEEDOR", caption: "NRC / NIT / DUI" },
                    { dataField: "NOMBRE DEL PROVEEDOR", caption: "Nombre del Proveedor" },
                    { dataField: "COMPRAS INTERNAS EXENTAS Y/O NO SUJETAS", 
                        caption: "Compras Exentas",
                        alignment: "right",
                        format: { type: "fixedPoint", precision: 2 }
                    },
                    { dataField: "COMPRAS INTERNAS GRAVADAS", 
                        caption: "Compras Gravadas Locales",
                        alignment: "right",
                        format: { type: "fixedPoint", precision: 2 }
                     },
                    { 
                        dataField: "CRÉDITO FISCAL", 
                        caption: "Crédito Fiscal",
                        alignment: "right",
                        format: { type: "fixedPoint", precision: 2 }
                     },
                    { 
                        dataField: "TOTAL DE COMPRAS", 
                        caption: "Total Compras",
                        alignment: "right",
                        format: { type: "fixedPoint", precision: 2 }
                    },
                    { 
                        dataField: "Retención a Terceros", 
                        caption: "Perc. IVA 1%",
                        alignment: "right",
                        format: { type: "fixedPoint", precision: 2 }
                    },
                    { 
                        dataField: "Retención 2%", 
                        caption: "Ant. IVA 2%",
                        alignment: "right",
                        format: { type: "fixedPoint", precision: 2 }
                    },
                    { 
                        dataField: "Compras a Sujeto Excluido", 
                        caption: "Compras a Sujeto Excluido",
                        alignment: "right",
                        format: { type: "fixedPoint", precision: 2 }
                    }
                ],
                hidePagination: false,
                AccountantName: JSON.parse(localStorage.getItem("user")).AccountantName,
                AccountantAdditional: JSON.parse(localStorage.getItem("user")).AccountantAdditional,
                AuditorName: JSON.parse(localStorage.getItem("user")).AuditorName,
                AuditorAdditional: JSON.parse(localStorage.getItem("user")).AuditorAdditional,
                invalidRowsCount: 0,
                editDialog: {
                    show: false,
                    data: {},
                    originalData: {}
                }
            }
        },
        computed:{
            ...mapGetters(["getCatalogMH"]),
            tipoIngresoProveedores() {
                return this.getCatalogMH('TipoIngresoProveedores');
            },
            sectorProveedores() {
                return this.getCatalogMH('SectorProveedores');
            }
        },
        watch: {
            printType() {
                this.DataTable = [];
            }
        },
        async mounted() {
            // Cargar catálogos de Hacienda
            await this.$store.dispatch('getCatalogMH');
            //this.yearLIst = ( await this.$API.accountingreports.getPurchaseOrderDateYears() ).years;
            //this.search.year = this.yearLIst[ this.yearLIst.length - 1 ].value;
            //this.monthList = ( await this.$API.accountingreports.getPurchaseOrderDateMonths( this.search ) ).months
            //this.search.month = this.monthList[ this.monthList.length - 1 ].monthIndex;
            this.search.year = new Date().getFullYear();
        },
        methods: {
            getCurrentBranchId() {
                const branchFromStorage = JSON.parse(localStorage.getItem("branch"))?.ID_Branch;
                const userBranch = JSON.parse(localStorage.getItem("user"))?.branch;
                return branchFromStorage || userBranch || null;
            },
            onIntegrateBranchDataChange() {
                this.search.ID_Branch = this.integrateBranchData ? 'all' : this.getCurrentBranchId();

                if (this.search.month != null && this.search.year != null) {
                    this.getReportSales();
                }
            },
            onRowPrepared(e) {
                if (e.rowType !== 'data') return;
                
                // Usar el array columns original en lugar de getVisibleColumns
                const columnsToCheck = this.printType === '1' ? this.columns : this.columns2;
                
                const hasRequiredEmpty = columnsToCheck.some(col => {
                    if (!col.required) return false;

                    const value = e.data[col.dataField];
                    return ( 
                        value === null ||
                        value === undefined ||
                        String(value).trim() === '' ||
                        String(value).trim() === 'null'
                    );
                });

                if (hasRequiredEmpty) {
                    e.rowElement.classList.add('errorRow');
                }
            },
            countInvalidRows(data, columns) {
                if (!Array.isArray(data) || !Array.isArray(columns) || this.printType == 2) return 0;

                const requiredFields = columns
                    .filter(col => col.required && col.dataField)
                    .map(col => col.dataField);

                if (requiredFields.length === 0) return 0;

                return data.filter(row =>
                    requiredFields.some(field => {
                        const value = row[field];
                        return (
                            value === null ||
                            value === undefined ||
                            String(value).trim() === '' ||
                            String(value).trim() === 'null'
                        );
                    })
                ).length;
            },
            getAlerts(){
                this.DataTable = this.sortByRequired(this.DataTable, this.columns);
            },
            sortByRequired(data, columns) {
                if (!Array.isArray(data) || !Array.isArray(columns)) return data;

                const requiredFields = columns
                    .filter(col => col.required && col.dataField)
                    .map(col => col.dataField);

                if (requiredFields.length === 0) return data;

                return [...data].sort((a, b) => {
                    const aInvalid = requiredFields.some(field => {
                        const v = a[field];
                        return v === null || v === undefined || String(v).trim() === '';
                    });

                    const bInvalid = requiredFields.some(field => {
                        const v = b[field];
                        return v === null || v === undefined || String(v).trim() === '';
                    });
                    return Number(bInvalid) - Number(aInvalid);
                });
            },
            customCurrencyFormat(value) {
                if (value == null) return ''; 
                return parseFloat(value).toFixed(2); 
            },
            async onExportingToPdf() {
                const doc = new jsPDF({orientation: 'l', format: 'letter'});
                var spColumnsWidth = []
                spColumnsWidth = [16, 56, 22, 45, 15, 15, 15, 20, 15, 15, 15];

                const [ businessInfo ] = await this.$API.branches.findSpecificBranch({ branch: JSON.parse(localStorage.getItem("user")).branch, business: JSON.parse(localStorage.getItem("user")).businessid })
                const fontSize = 7;
                const espacioPostTabla = 20;
                let lastPointPerPage = {};
                let currentPageInDraw = 1;
                exportDataGrid({
                    jsPDFDocument: doc,
                    component: this.$refs["dxdatagridcompras"].instance,
                    topLeft: { x: 0, y: 0 },
                    margin:{
                        top: 26,
                        left: 15,
                        bottom: 15
                    },
                    columnWidths: spColumnsWidth,
                    customizeCell: function (options) {
                        options.pdfCell.font.size = fontSize;
                    },
                    customDrawCell({ rect }) {
                        if (rect.y < 50 && lastPointPerPage[currentPageInDraw] && lastPointPerPage[currentPageInDraw].y > 100) {
                            currentPageInDraw++;
                        }
                        if (!lastPointPerPage[currentPageInDraw]) {
                            lastPointPerPage[currentPageInDraw] = { x: 0, y: 0 };
                        }
                        if (lastPointPerPage[currentPageInDraw].x < rect.x + rect.w) {
                            lastPointPerPage[currentPageInDraw].x = rect.x + rect.w;
                        }
                        if (lastPointPerPage[currentPageInDraw].y < rect.y + rect.h) {
                            lastPointPerPage[currentPageInDraw].y = rect.y + rect.h;
                        }
                    },
                }).then(() => {
                    var pageCount = doc.internal.getNumberOfPages();
                    for(var i = 0; i < pageCount; i++){
                        doc.setPage(i + 1);
                        doc.setFontSize(fontSize)
                        if(!this.hidePagination) {
                            let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
                            doc.text('page: ' + pageCurrent + ' / ' + pageCount, 10, 10);
                        }
                        let month = this.monthList.find(item => item.monthIndex === this.search.month)
                        var header = `${ businessInfo.BusinessBillingName }`
                        var header1 = `Libro de Compras`;
                        var header2 = `Registro de IVA Número: ${JSON.parse(localStorage.getItem("user")).businessnrc}`
                        var header3 = `Periodo Tributario: ${month.monthName} de ${this.search.year}`
                        var header4 = `Cantidades Expresadas en Dolares de Estados Unidos de America`
                        
                        const pageWidth = doc.internal.pageSize.getWidth();
                        const headerWidth = doc.getTextDimensions(header).w;
                        const headerWidth1 = doc.getTextDimensions(header1).w;
                        const headerWidth2 = doc.getTextDimensions(header2).w;
                        const headerWidth3 = doc.getTextDimensions(header3).w;
                        const headerWidth4 = doc.getTextDimensions(header4).w;
                        doc.setFontSize(10);
                        let y = 4;
                        let line = 4;
                        doc.setFont('helvetica', 'bold');
                        doc.text(header, (pageWidth - headerWidth) / 2, y+=line);
                        doc.setFont('helvetica', 'normal');
                        doc.text(header1, (pageWidth - headerWidth1) / 2, y+=line);
                        doc.text(header2, (pageWidth - headerWidth2) / 2, y+=line);
                        doc.text(header3, (pageWidth - headerWidth3) / 2, y+=line);
                        doc.text(header4, (pageWidth - headerWidth4) / 2, y+=line);
                    }
                    doc.setPage(pageCount);
                    let lastPagePoint = lastPointPerPage[currentPageInDraw] || lastPointPerPage[Object.keys(lastPointPerPage).pop()];
                    let currentY = lastPagePoint ? lastPagePoint.y + espacioPostTabla : 30;
                    const pageHeight = doc.internal.pageSize.getHeight();
                    const spaceMin = 30;
                    
                    if (currentY + spaceMin > pageHeight - 15) {
                        doc.addPage();
                        currentY = 15;
                    }

                    addSignaturesAccountantAndAuditor({
                        doc, 
                        positionY: currentY, 
                        leftLineMargin: 15,
                        longLine: 105,
                        AccountantName: this.AccountantName, 
                        AccountantAdditional: this.AccountantAdditional, 
                        AuditorName: this.AuditorName,
                        AuditorAdditional: this.AuditorAdditional,
                        AuditorShow: false
                    })
                    doc.save('Reporte de Compras');
                });
            },
            async getMonths(){
                this.monthList = ( await this.$API.accountingreports.getPurchaseOrderDateMonths( this.search ) ).months
                 this.search.month = this.monthList[ this.monthList.length - 1 ].monthIndex;
            },
            printconfig(){
                
                this.print.show = false;
                const month = this.monthList.find( (element) => element.monthIndex == this.search.month );
                console.log(month);
                this.print.header.month = month.monthName;
                this.print.header.year = this.search.year;
                
                this.print.data.body = this.DataTable;
                console.log(this.print.data.body);
                //this.reloadPrint++;
                this.print.show = true;

                this.windowsList.push({
                    component: SubPrint,
                    props: {
                        print: this.print,
                        IsPurchase: true              
                    },
                    key: new Date().getTime(),
                });          
           },
            filterHandler(data) {
                this.DataTable = data.data.data;
                this.DataTable.forEach((element, index) => {
                      element.index = index + 1;
                    });
            },
           getReportSales(){
            if(this.search.month == null || this.search.year == null){
                    
                    return;
            }
           
            this.loading = true;

            const endpointConfig = {
                '1': 'getPurchasesByDate',
                '2': 'getPurchasesByDateMHFormat'
            }

            console.log( 'this.printType ', this.printType );

            const requestParams = {
                ...this.search,
                ID_Branch: this.integrateBranchData ? 'all' : this.getCurrentBranchId()
            };

            this.$API.accountingreports[ endpointConfig[ this.printType ] ](requestParams).then((res) => {
               
                this.DataTable = res.data.data;

                this.DataTable.forEach((element, index) => {
                      element.index = index + 1;
                    });
                this.loading = false;
                this.invalidRowsCount = this.countInvalidRows(this.DataTable, this.columns)
            }).catch((err) => {
                this.loading = false;
                this.showAlert("danger", "Error", err.response.data.message);
            });
           },
           closeAlert() {
                this.alert.show = false;
            },
            acceptAlert() {
                this.alert.show = false;

            
            },
            onExporting(e) {
                const array = [ "No Sujeta", "ISLR", "IVA", "Retencion", "Sub total ", "Total" ];
              printToExcel(e, "Reporte de Compras", array);
            },
            showAlert(type, header, body, options = null) {
                type = type == null ? "danger" : type;
                this.alert.type = type;
                this.alert.header = header;
                this.alert.body = body;
                this.alert.show = true;
                this.alert.options = options != null ? options : null;
            },
            hasEmptyRequiredFields(row) {
                if (!row || this.printType == '2') return false;
                
                const requiredFields = this.columns
                    .filter(col => col.required && col.dataField)
                    .map(col => col.dataField);

                return requiredFields.some(field => {
                    const value = row[field];
                    return (
                        value === null ||
                        value === undefined ||
                        String(value).trim() === '' ||
                        String(value).trim() === 'null'
                    );
                });
            },
            openEditDialog(rowData) {
                this.editDialog.data = { ...rowData };
                this.editDialog.originalData = rowData;
                this.editDialog.show = true;
            },
            closeEditDialog() {
                this.editDialog.show = false;
                this.editDialog.data = {};
                this.editDialog.originalData = {};
            },
            isFormValid() {
                const requiredFields = [
                    'CLASIFICACIÓN',
                    'SECTOR',
                    'TIPO DE COSTO / GASTO'
                ];

                return requiredFields.every(field => {
                    const value = this.editDialog.data[field];
                    return value && String(value).trim() !== '' && String(value).trim() !== 'null';
                });
            },
            async saveEditedData() {
                if (!this.isFormValid()) {
                    this.showAlert("warning", "Campos incompletos", "Por favor complete todos los campos requeridos.");
                    return;
                }

                try {
                    this.loading = true;

                    // Obtener ID_PurchaseOrder para detectar el tipo de registro
                    const purchaseOrderId = this.editDialog.originalData['ID_PurchaseOrder'];
                    const documentNumber = this.editDialog.originalData['NÚMERO DE DOCUMENTO'];
                    
                    // Detectar si es Purchase Order (correlativo tipo "PO2023060001") o Expense Entry (numérico tipo "88")
                    const isPurchaseOrder = isNaN(purchaseOrderId) || String(purchaseOrderId).includes('PO');
                    
                    // Preparar los datos comunes
                    const commonData = {
                        ClasificationRent: this.editDialog.data['CLASIFICACIÓN'],
                        SectorProveedores: this.editDialog.data['SECTOR'],
                        TipoIngresoProveedores: this.editDialog.data['TIPO DE COSTO / GASTO']
                    };

                    // Llamar al endpoint correspondiente
                    if (isPurchaseOrder) {
                        // Es una orden de compra (inventory_purchase_order_header)
                        await this.$API.orders.updatePurchaseOrderClassification({
                            id: purchaseOrderId,
                            ...commonData
                        });
                    } else {
                        // Es un gasto contable (accounting_expenses_entry)
                        await this.$API.accountingexpensesentry.updateEntryClassificationByDocument({
                            documentNumber: documentNumber,
                            type: 'gastos', // Siempre 'gastos' para registros numéricos
                            ...commonData,
                            CustomCSVPeriodFlag: 0,
                            CustomCSVPeriodMonth: null,
                            CustomCSVPeriodYear: null,
                            id: purchaseOrderId
                        });
                    }

                    // Actualizar los datos en el objeto original
                    this.editDialog.originalData['CLASIFICACIÓN'] = this.editDialog.data['CLASIFICACIÓN'];
                    this.editDialog.originalData['SECTOR'] = this.editDialog.data['SECTOR'];
                    this.editDialog.originalData['TIPO DE COSTO / GASTO'] = this.editDialog.data['TIPO DE COSTO / GASTO'];
                    
                    // Actualizar el conteo de filas inválidas
                    this.invalidRowsCount = this.countInvalidRows(this.DataTable, this.columns);

                    this.showAlert("success", "Éxito", "Los datos se han actualizado correctamente.");
                    this.closeEditDialog();
                } catch (error) {
                    this.showAlert("danger", "Error", error.response?.data?.message || "Error al actualizar los datos");
                } finally {
                    this.loading = false;
                }
            },
            async onExportingToExcel() {
                try {
                    this.loading = true;

                    // Obtener datos del endpoint
                    const params = {
                        month: this.search.month,
                        year: this.search.year,
                        ID_Branch: this.integrateBranchData ? 'all' : this.getCurrentBranchId()
                    };

                    const response = await this.$API.accountingreports.getPurchasesBookExcelData(params);
                    
                    if (!response.data || !response.data.data) {
                        throw new Error('No se pudieron obtener los datos');
                    }

                    const datosCompras = response.data.data || [];

                    if (datosCompras.length === 0) {
                        this.showAlert("warning", "Advertencia", "No hay datos disponibles para generar el Excel.");
                        return;
                    }

                    // Generar Excel
                    await this.generateExcelPurchases(datosCompras);
                    
                } catch (error) {
                    console.error('Error al generar Excel:', error);
                    this.showAlert("danger", "Error", error.response?.data?.message || "Ocurrió un error al generar el archivo Excel.");
                } finally {
                    this.loading = false;
                }
            },
            async generateExcelPurchases(datosCompras) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Compras');
                
                // Obtener información del negocio
                const [ businessInfo ] = await this.$API.branches.findSpecificBranch({ 
                    branch: JSON.parse(localStorage.getItem("user")).branch, 
                    business: JSON.parse(localStorage.getItem("user")).businessid 
                });
                const businessName = this.sanitizeText(businessInfo.BusinessBillingName || '');
                const month = this.monthList.find(item => item.monthIndex === this.search.month);
                
                // Configurar ancho de columnas (según imagen adjunta)
                worksheet.columns = [
                    { width: 4.5 },   // A: N
                    { width: 12 },    // B: FECH. DE EMISIÓN
                    { width: 24 },    // C: NUMERO DE DOCUMENTO
                    { width: 13 },    // D: NRC
                    { width: 16 },    // E: NIT o DUI
                    { width: 42 },    // F: NOMBRE DEL PROVEEDOR
                    { width: 11 },    // G: COMPRAS NO SUJETAS
                    { width: 11 },    // H: COMPRAS EXENTAS
                    { width: 11 },    // I: IMPORTAC. E INTERNAC.
                    { width: 11 },    // J: INTERNAS
                    { width: 11 },    // K: IMPORTAC ION
                    { width: 11 },    // L: INTERNAC ION
                    { width: 11 },    // M: CRÉDITO FISCAL
                    { width: 11 },    // N: SUJETOS EXCLUIDOS
                    { width: 11 },    // O: TOTAL DE COMPRAS
                    { width: 11 },    // P: 10% ISR
                    { width: 11 },    // Q: RETENID O
                    { width: 11 },    // R: PERCIBID O
                    { width: 11 },    // S: ANTICIPO A CUENTA
                ];
                
                // Color de fondo azul claro
                const fillBlue = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFB4C7E7' }
                };
                
                // Bordes estándar
                const borderStyle = {
                    top: { style: 'thin', color: { argb: 'FF000000' } },
                    left: { style: 'thin', color: { argb: 'FF000000' } },
                    bottom: { style: 'thin', color: { argb: 'FF000000' } },
                    right: { style: 'thin', color: { argb: 'FF000000' } }
                };
                
                // Aplicar fondo azul a todo el bloque del encabezado (A2:S6)
                for (let row = 2; row <= 6; row++) {
                    for (let col = 1; col <= 19; col++) { // A hasta S
                        const cell = worksheet.getCell(row, col);
                        cell.fill = fillBlue;
                    }
                }
                
                // Encabezado principal - Nombre de la empresa y título (filas 2-4, centrado en columnas D-O)
                worksheet.mergeCells('D2:O4');
                const headerCell = worksheet.getCell('D2');
                headerCell.value = `${businessName.toUpperCase()}\nLIBRO O REGISTRO DE COMPRAS`;
                headerCell.font = { bold: true, size: 11 };
                headerCell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                headerCell.fill = fillBlue;
                headerCell.border = borderStyle;
                
                // Fila 5 - MES (izquierda)
                worksheet.mergeCells('B5:C5');
                const mesLabelCell = worksheet.getCell('B5');
                mesLabelCell.value = 'MES :';
                mesLabelCell.font = { bold: true, size: 10 };
                mesLabelCell.alignment = { horizontal: 'center', vertical: 'middle' };
                mesLabelCell.fill = fillBlue;
                mesLabelCell.border = borderStyle;
                
                worksheet.getCell('D5').value = month.monthName.toUpperCase();
                worksheet.getCell('D5').font = { bold: true, size: 10 };
                worksheet.getCell('D5').alignment = { horizontal: 'center', vertical: 'middle' };
                worksheet.getCell('D5').fill = fillBlue;
                worksheet.getCell('D5').border = borderStyle;
                
                // Fila 5 - N.R.C. (derecha)
                worksheet.mergeCells('N5:O5');
                const nrcLabelCell = worksheet.getCell('N5');
                nrcLabelCell.value = 'N.R.C.';
                nrcLabelCell.font = { bold: true, size: 10 };
                nrcLabelCell.alignment = { horizontal: 'center', vertical: 'middle' };
                nrcLabelCell.fill = fillBlue;
                nrcLabelCell.border = borderStyle;
                
                worksheet.mergeCells('P5:S5');
                const nrcValueCell = worksheet.getCell('P5');
                nrcValueCell.value = JSON.parse(localStorage.getItem("user")).businessnrc;
                nrcValueCell.font = { bold: false, size: 10 };
                nrcValueCell.alignment = { horizontal: 'center', vertical: 'middle' };
                nrcValueCell.fill = fillBlue;
                nrcValueCell.border = borderStyle;
                
                // Fila 6 - AÑO (izquierda)
                worksheet.mergeCells('B6:C6');
                const anoLabelCell = worksheet.getCell('B6');
                anoLabelCell.value = 'AÑO :';
                anoLabelCell.font = { bold: true, size: 10 };
                anoLabelCell.alignment = { horizontal: 'center', vertical: 'middle' };
                anoLabelCell.fill = fillBlue;
                anoLabelCell.border = borderStyle;
                
                worksheet.getCell('D6').value = this.search.year;
                worksheet.getCell('D6').font = { bold: true, size: 10 };
                worksheet.getCell('D6').alignment = { horizontal: 'center', vertical: 'middle' };
                worksheet.getCell('D6').fill = fillBlue;
                worksheet.getCell('D6').border = borderStyle;
                
                // Fila 6 - NIT (derecha)
                worksheet.mergeCells('N6:O6');
                const nitLabelCell = worksheet.getCell('N6');
                nitLabelCell.value = 'NIT';
                nitLabelCell.font = { bold: true, size: 10 };
                nitLabelCell.alignment = { horizontal: 'center', vertical: 'middle' };
                nitLabelCell.fill = fillBlue;
                nitLabelCell.border = borderStyle;
                
                worksheet.mergeCells('P6:S6');
                const nitValueCell = worksheet.getCell('P6');
                nitValueCell.value = JSON.parse(localStorage.getItem("user")).businessnit || '';
                nitValueCell.font = { bold: false, size: 10 };
                nitValueCell.alignment = { horizontal: 'center', vertical: 'middle' };
                nitValueCell.fill = fillBlue;
                nitValueCell.border = borderStyle;
                
                // Encabezados de columnas - Nivel 1 (Fila 9)
                const headerRow = 9;
                worksheet.getRow(headerRow).height = 30;
                worksheet.getRow(headerRow + 1).height = 30;
                
                // Columnas simples (A-F)
                worksheet.mergeCells(`A${headerRow}:A${headerRow + 1}`);
                worksheet.getCell(`A${headerRow}`).value = 'N';
                
                worksheet.mergeCells(`B${headerRow}:B${headerRow + 1}`);
                worksheet.getCell(`B${headerRow}`).value = 'FECH. DE EMISIÓN';
                
                worksheet.mergeCells(`C${headerRow}:C${headerRow + 1}`);
                worksheet.getCell(`C${headerRow}`).value = 'NUMERO DE DOCUMENTO';
                
                worksheet.mergeCells(`D${headerRow}:D${headerRow + 1}`);
                worksheet.getCell(`D${headerRow}`).value = 'NRC';
                
                worksheet.mergeCells(`E${headerRow}:E${headerRow + 1}`);
                worksheet.getCell(`E${headerRow}`).value = 'NIT o DUI';
                
                worksheet.mergeCells(`F${headerRow}:F${headerRow + 1}`);
                worksheet.getCell(`F${headerRow}`).value = 'NOMBRE DEL PROVEEDOR';
                
                // COMPRAS EXENTAS/NO SUJETAS (G-I)
                worksheet.mergeCells(`G${headerRow}:I${headerRow}`);
                worksheet.getCell(`G${headerRow}`).value = 'COMPRAS EXENTAS/NO SUJETAS';
                worksheet.getCell(`G${headerRow}`).fill = fillBlue;
                
                worksheet.getCell(`G${headerRow + 1}`).value = 'COMPRAS NO SUJETAS';
                worksheet.getCell(`H${headerRow + 1}`).value = 'COMPRAS EXENTAS';
                worksheet.getCell(`I${headerRow + 1}`).value = 'IMPORTAC. E INTERNAC.';
                
                // COMPRAS GRAVADAS (J-M)
                worksheet.mergeCells(`J${headerRow}:M${headerRow}`);
                worksheet.getCell(`J${headerRow}`).value = 'COMPRAS GRAVADAS';
                worksheet.getCell(`J${headerRow}`).fill = fillBlue;
                
                worksheet.getCell(`J${headerRow + 1}`).value = 'INTERNAS';
                worksheet.getCell(`K${headerRow + 1}`).value = 'IMPORTAC ION';
                worksheet.getCell(`L${headerRow + 1}`).value = 'INTERNAC ION';
                worksheet.getCell(`M${headerRow + 1}`).value = 'CRÉDITO FISCAL';
                
                
                // SUJETOS EXCLUIDOS (N)
                worksheet.mergeCells(`N${headerRow}:N${headerRow + 1}`);
                worksheet.getCell(`N${headerRow}`).value = 'SUJETOS EXCLUIDOS';
                
                // TOTAL DE COMPRAS (O)
                worksheet.mergeCells(`O${headerRow}:O${headerRow + 1}`);
                worksheet.getCell(`O${headerRow}`).value = 'TOTAL DE COMPRAS';
                
                // 10% ISR (P)
                worksheet.mergeCells(`P${headerRow}:P${headerRow + 1}`);
                worksheet.getCell(`P${headerRow}`).value = '10% ISR';
                
                // IVA RETENIDO (Q) - sin agrupar
                worksheet.mergeCells(`Q${headerRow}:Q${headerRow + 1}`);
                worksheet.getCell(`Q${headerRow}`).value = 'IVA RETENIDO';
                
                // IVA PERCIBIDO (R) - sin agrupar
                worksheet.mergeCells(`R${headerRow}:R${headerRow + 1}`);
                worksheet.getCell(`R${headerRow}`).value = 'IVA PERCIBIDO';
                
                // ANTICIPO A CUENTA (S)
                worksheet.mergeCells(`S${headerRow}:S${headerRow + 1}`);
                worksheet.getCell(`S${headerRow}`).value = 'ANTICIPO A CUENTA';
                
                // Aplicar estilos a encabezados
                for (let col = 1; col <= 19; col++) {
                    for (let row = headerRow; row <= headerRow + 1; row++) {
                        const cell = worksheet.getCell(row, col);
                        cell.font = { bold: true, size: 8 };
                        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                }
                
                // Agregar datos
                let rowIndex = headerRow + 2;
                let totales = {
                    comprasNoSujetas: 0,
                    comprasExentas: 0,
                    importacInternac: 0,
                    internas: 0,
                    importacIon: 0,
                    internacIon: 0,
                    creditoFiscal: 0,
                    sujetosExcluidos: 0,
                    totalCompras: 0,
                    isr: 0,
                    ivaRetenido: 0,
                    ivaPercibido: 0,
                    anticipoCuenta: 0
                };
                
                datosCompras.forEach((item, index) => {
                    const row = worksheet.getRow(rowIndex);
                    
                    // Determinar si es NRC o NIT/DUI según cantidad de caracteres
                    const nitNrcProveedor = item['NIT O NRC DEL PROVEEDOR'] || '';
                    const nitSujetoExcluido = item['NIT Sujeto Excluido'] || '';
                    const length = nitNrcProveedor.length;
                    
                    row.getCell(1).value = index + 1;
                    row.getCell(2).value = item['FECHA DE EMISIÓN'] || '';
                    row.getCell(3).value = item['NÚMERO DE DOCUMENTO'] || '';
                    
                    // Columna D (NRC): si NO tiene 9 o 14 caracteres
                    row.getCell(4).value = (length !== 9 && length !== 14) ? nitNrcProveedor : '';
                    
                    // Columna E (NIT o DUI): primero NIT Sujeto Excluido, luego si tiene 9 o 14 caracteres
                    row.getCell(5).value = nitSujetoExcluido || ((length === 9 || length === 14) ? nitNrcProveedor : '');
                    
                    row.getCell(6).value = item['NOMBRE DEL PROVEEDOR'] || '';
                    row.getCell(7).value = parseFloat(item['nosujeto']) || 0;
                    row.getCell(8).value = parseFloat(item['exento']) || 0;
                    row.getCell(9).value = parseFloat(item['COMPRAS_IMPORTACION_EXENTAS_NOSUJETAS']) || 0;
                    row.getCell(10).value = parseFloat(item['COMPRAS INTERNAS GRAVADAS']) || 0;
                    row.getCell(11).value = parseFloat(item['COMPRAS_IMPORTACION_GRAVADAS']) || 0;
                    row.getCell(12).value = parseFloat(item['COMPRAS_INTERNACION_GRAVADAS']) || 0;
                    row.getCell(13).value = parseFloat(item['CRÉDITO FISCAL']) || 0;
                    row.getCell(14).value = parseFloat(item['Compras a Sujeto Excluido']) || 0;
                    row.getCell(15).value = parseFloat(item['total']) || 0;
                    row.getCell(16).value = parseFloat(item['renta']) || 0;
                    row.getCell(17).value = parseFloat(item['Retención a Terceros']) || 0;
                    row.getCell(18).value = parseFloat(item['PERCIBIDO']) || 0;
                    row.getCell(19).value = parseFloat(item['Retención 2%']) || 0;
                    
                    // Formato números con símbolo $ y separador de miles
                    for (let col = 7; col <= 19; col++) {
                        const cell = row.getCell(col);
                        cell.numFmt = '$#,##0.00;[Red]($#,##0.00)';
                        cell.alignment = { horizontal: 'right', vertical: 'middle' };
                        cell.font = { size: 9 };
                    }
                    
                    // Alineación columnas de texto
                    row.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                    row.getCell(2).alignment = { horizontal: 'center', vertical: 'middle' };
                    row.getCell(6).alignment = { horizontal: 'left', vertical: 'middle' };
                    
                    // Bordes
                    for (let col = 1; col <= 19; col++) {
                        const cell = row.getCell(col);
                        cell.border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                    
                    // Acumular totales
                    totales.comprasNoSujetas += parseFloat(item['nosujeto']) || 0;
                    totales.comprasExentas += parseFloat(item['exento']) || 0;
                    totales.importacInternac += parseFloat(item['COMPRAS_IMPORTACION_EXENTAS_NOSUJETAS']) || 0;
                    totales.internas += parseFloat(item['COMPRAS INTERNAS GRAVADAS']) || 0;
                    totales.importacIon += parseFloat(item['COMPRAS_IMPORTACION_GRAVADAS']) || 0;
                    totales.internacIon += parseFloat(item['COMPRAS_INTERNACION_GRAVADAS']) || 0;
                    totales.creditoFiscal += parseFloat(item['CRÉDITO FISCAL']) || 0;
                    totales.sujetosExcluidos += parseFloat(item['Compras a Sujeto Excluido']) || 0;
                    totales.totalCompras += parseFloat(item['total']) || 0;
                    totales.isr += parseFloat(item['renta']) || 0;
                    totales.ivaRetenido += parseFloat(item['Retención a Terceros']) || 0;
                    totales.ivaPercibido += parseFloat(item['PERCIBIDO']) || 0;
                    totales.anticipoCuenta += parseFloat(item['Retención 2%']) || 0;
                    
                    rowIndex++;
                });
                
                // Fila de TOTALES con fondo azul
                const totalRow = worksheet.getRow(rowIndex);
                worksheet.mergeCells(`A${rowIndex}:F${rowIndex}`);
                totalRow.getCell(1).value = 'TOTAL DE COMPRAS';
                totalRow.getCell(1).font = { bold: true, size: 10 };
                totalRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                totalRow.getCell(1).fill = fillBlue;
                
                totalRow.getCell(7).value = totales.comprasNoSujetas;
                totalRow.getCell(8).value = totales.comprasExentas;
                totalRow.getCell(9).value = totales.importacInternac;
                totalRow.getCell(10).value = totales.internas;
                totalRow.getCell(11).value = totales.importacIon;
                totalRow.getCell(12).value = totales.internacIon;
                totalRow.getCell(13).value = totales.creditoFiscal;
                totalRow.getCell(14).value = totales.sujetosExcluidos;
                totalRow.getCell(15).value = totales.totalCompras;
                totalRow.getCell(16).value = totales.isr;
                totalRow.getCell(17).value = totales.ivaRetenido;
                totalRow.getCell(18).value = totales.ivaPercibido;
                totalRow.getCell(19).value = totales.anticipoCuenta;
                
                // Formato fila totales
                for (let col = 7; col <= 19; col++) {
                    const cell = totalRow.getCell(col);
                    cell.numFmt = '$#,##0.00;[Red]($#,##0.00)';
                    cell.font = { bold: true, size: 10 };
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                    cell.fill = fillBlue;
                }
                
                // Bordes fila totales
                for (let col = 1; col <= 19; col++) {
                    const cell = totalRow.getCell(col);
                    cell.border = {
                        top: { style: 'medium' },
                        left: { style: 'thin' },
                        bottom: { style: 'medium' },
                        right: { style: 'thin' }
                    };
                }
                
                // Generar y descargar el archivo
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(blob, `Libro_Compras_${month.monthName}_${this.search.year}.xlsx`);
                
                this.showAlert("success", "Éxito", "El archivo Excel se ha generado correctamente.");
            },
            sanitizeText(text = '') {
                return text
                    .replace(/[\u2013\u2014]/g, '-')
                    .replace(/[^\x20-\x7EñÑáéíóúÁÉÍÓÚüÜ¿¡]/g, '')
                    .trim();
            }
        },

    }
</script>

<style scoped>
:deep(.errorRow){
    background-color: #fff3cd !important;
  color: #856404 !important;
  font-weight: bold;
}
.bar {
  width: 100%;
  background-color: rgb(60, 60, 60) !important;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-radius: 15px !important;
  margin-top: 1rem !important;
}
.btn-add{
  background-color: #3498DB  !important;
  color: white;
}
.btnsave{
  background-color: #00A178 !important;
  color: white;
}
.btnclean{
  background-color: #F29D35 !important;
  color: white;
}
.btndelete{
  background-color: #E3191E !important;
  color: white;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row .right-column {
    text-align: center !important;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row .left-column {
    text-align: center !important;
}

.dx-datagrid-headers .dx-datagrid-table .dx-row .center-column {
    text-align: center !important;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .right-column {
    text-align: right !important;
    font-size: 10px;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .left-column {
    text-align: left !important;
    font-size: 10px;
}

.dx-datagrid-content .dx-datagrid-table .dx-data-row .center-column {
    text-align: center !important;
    font-size: 10px;
}
</style>
